// src/components/GoogleAnalytics.jsx
// The gtag.js script itself + initial pageview are loaded directly in
// public/index.html. This component only handles the part index.html
// *can't* do: tracking client-side route changes as pageviews, since
// React Router navigates without a full page reload.
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function GoogleAnalytics() {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false; // skip — index.html's gtag('config', ...) already sent this one
      return;
    }
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location.pathname, location.search]);

  return null;
}

